import { render, staticRenderFns } from "./PagePagination.vue?vue&type=template&id=4691ab6c&scoped=true"
import script from "./PagePagination.vue?vue&type=script&lang=js"
export * from "./PagePagination.vue?vue&type=script&lang=js"
import style0 from "./PagePagination.vue?vue&type=style&index=0&id=4691ab6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4691ab6c",
  null
  
)

export default component.exports